import { render, staticRenderFns } from "./orderProfitsByProduct.vue?vue&type=template&id=91763a84&"
import script from "./orderProfitsByProduct.vue?vue&type=script&lang=js&"
export * from "./orderProfitsByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports